import { ProgressBar } from "react-bootstrap";
import { DatasetImage } from "./api/Application";
import { datasetImageThumbnailUrl } from "./api/Url";
import { forwardRef } from "react";

interface DatasetImageItemProps {
    image: DatasetImage;
    onClick: () => void;
    isSelected: boolean;
}

export const DatasetImageItem = forwardRef<HTMLDivElement, DatasetImageItemProps>(
    ( { image, onClick, isSelected }: DatasetImageItemProps, ref ) => {
    const selStyle = "border border-primary";
    const baseStyle = "match-item mx-2 my-1 mb-1 p-3 rounded-4 d-flex align-items-center border shadow";
    const style = `${isSelected ? selStyle : ""} ${baseStyle}`;
    return <div className={style} id={`${image.datasetImageId}`} ref={ref}
            style={{ cursor: 'pointer' }}
            onClick={onClick}>
            <div className="mx-2 d-flex flex-column flex-shrink-0">
                <img height={64} width={64} loading="lazy" src={datasetImageThumbnailUrl( image.datasetImageId, 256 )} />
            </div>
            <div className="d-flex flex-column gap-2 p-3 w-100">
                <div>
                    Image #{image.datasetImageId}
                </div>
                <div className="position-relative">
                    <ProgressBar
                        className="rounded-1 mw-100 shadow-sm"
                        style={{ height: "2em" }} 
                        now={image.annotatedCount} 
                        max={image.objectCount} />
                        <span
                            style={{
                                position: "absolute",
                                inset: 0,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                color: "white",
                                WebkitTextStroke: "2px rgba(0,0,0,0.3)",
                                paintOrder: "stroke fill",
                                pointerEvents: "none",
                            }}>
                            {image.annotatedCount} / {image.objectCount}
                    </span>
                </div>
            </div>
        </div>;
} );